import { useEffect, useState } from 'react';

import Base from '../../../../utils/base'
import CustomTable from '../../../../layout/custom_table/index'

export default function BlogSustainability() {
  var base = new Base()
  const [arr_header, set_arr_header] = useState([
    {
      label: base.i18n.t('image'),
      data: 'file_name',
      type: 'image',
    },
    {
      label: base.i18n.t('title'),
      data: 'title',
    },
    {
      label: base.i18n.t('status_publish'),
      data: 'status_publish',
    },
  ])
  const [arr, set_arr] = useState([])

  function on_update_data(arr){
    arr.forEach((data, index) => {
      if(data.file_name != null)
        data.file_name = base.host + '/image/blog?file_name=' + data.file_name
      if(data.title == null || data.title === '')
        data.title = '-'
      data.status_publish = data.is_publish === 1 ? 'Published' : 'Unpublished'
    })
    set_arr(arr)
  }

  return (
    <div>
      <h3>{base.i18n.t('collection')}</h3>
      <CustomTable
        url='/blog/home?blog_home_type_name=collection'
        arr_header={arr_header}
        arr={arr}
        url_update='/blog/collection/action'
        url_create='/blog/collection/action'
        url_delete='/blog/collection'
        on_update_data={data => on_update_data(data)}/>
    </div>
  );
}
